import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const EventAnimateY = keyframes`
  0%{
    transform: translateY(100%)
  }
  100%{
    transform: translateY(0%)
  }
`;

const EventAnimateX = keyframes`
  0%{
    transform: translateX(100%)
  }
  100%{
    transform: translateX(0%)
  }
`;

const BgAnimate = keyframes`
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
`;

const StyledCalendarEvent = styled.div`
  background-color: ${props =>
    props.eventDay ? props.theme.colors.colorOne : props.theme.colors.light};

  width: 100%;
  min-height: calc(100vh - 179px);
  z-index: 5;
  ${props =>
    props.transform ? `transform: translateY(${props.transform}px)` : ''};
  ${props =>
    props.transition &&
    `
    transition: 0.5s ease-in-out;
  `};

  ${mediaqueries.greaterThan('tablet')`
    top:${rem('60px')};
      position: relative;
      border: 2px ${props => props.theme.colors.grayLighter} solid;   
      box-shadow: ${rem('-4px')} ${rem('1px')} ${rem('6px')} ${rem(
    '-4px'
  )} ${props => props.theme.colors.gray};   
  `};

  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('600px')};
    width:${rem('300px')};
    transition: none;
    transform: none;
    z-index: 6;
    min-height: auto;
  `};
`;

const StyledCalendarEventHour = StyledCalendarEvent.extend`
  bottom: auto;
  height: 100vh;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  animation: ${EventAnimateY} 0.3s ease;
  ${mediaqueries.greaterThan('tablet')`
    position:absolute;
    left: 0;
    top: 0;
    height: 100vh;
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('600px')};
    position: relative;
    top: 0;
    width: ${rem('300px')};
    animation: none;
  `};
`;
const WrapperHour = styled.div`
  display: flex;
  ${mediaqueries.greaterThan('desktop')`
    animation: ${EventAnimateX} 0.3s ease;
    position: absolute;
    right: 0;
    top: ${rem('60px')};
    z-index: 7;
  `};
`;

const BgHour = styled.div`
  display: block;
  width: 100%;
  height: ${rem('600px')};
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  right: auto;
  top: ${rem('60px')};
  z-index: 5;
  animation: ${BgAnimate} 0.15s linear;
`;

const StyledCalendarEventNot = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.light}85;
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  height: ${rem('118px')};
  margin: ${rem('20px')} 0 0;
  text-align: center;
  text-transform: uppercase;

  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('157px')};
    margin: ${rem('30px')} 0 0;
  `};

  ${mediaqueries.greaterThan('desktop')`
    align-items: center;
    margin: ${rem('70px')} auto 0;
    width: ${rem('300px')};
  `};
`;

const StyleIconNotEvent = styled(Icon)`
  margin: ${rem('10px')} 0 0;

  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('54px')};
    width: ${rem('54px')};
  `};
`;

const StyledButtonToday = styled.button`
  background-color: ${props => props.theme.colors.colorOneDark};
  border: none;
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  padding: ${rem('7px')} ${rem('20px')};

  ${mediaqueries.greaterThan('desktop')`
    position: absolute;
    right: 0;
    top: -${rem('40px')};
  `};
`;

const StyledListEvent = styled.ul`
  font-size: ${rem('14px')};
  margin: 0;
  padding: 0;

  ${mediaqueries.greaterThan('desktop')`
    display: list-item;
    padding-top: ${rem('28px')};
    padding-left: ${rem('40px')};
    overflow-y: auto;
    overflow-x: hidden;
    max-height: ${rem('486px')};
  `};
`;

const StyledListEventItem = styled.li`
  border-bottom: 1px solid ${props => props.theme.colors.dark}1A;
  color: ${props => props.theme.colors.light};
  display: block;
  padding: ${rem('15px')};
  cursor: pointer;
  :before {
    content: none;
  }

  ${mediaqueries.greaterThan('mobile')`
    display: flex;
    padding: ${rem('15px')} ${rem('30px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    border: none;
    display: list-item;
    list-style-type: disc;
    padding-left: 0; 
    width:${rem('268px')};
  `};
`;

const StyledListEventName = styled.span`
  font-family: ${props => props.theme.fonts.medium};

  ${mediaqueries.greaterThan('mobile')`
    flex: 0 1 50%;
  `};
`;

const StyledListEventHours = styled.span`
  font-family: ${props => props.theme.fonts.book};
  padding-left: 0;

  :after {
    content: '/';
    font-family: ${props => props.theme.fonts.bold};
    margin: 0 10px;
  }

  :last-child {
    :after {
      content: none;
    }
  }

  ${mediaqueries.greaterThan('desktop')`
    display: block;
    :after {
      content: none;
  `};
`;

export {
  StyledCalendarEvent,
  StyledCalendarEventHour,
  StyledCalendarEventNot,
  StyleIconNotEvent,
  StyledButtonToday,
  StyledListEvent,
  StyledListEventName,
  StyledListEventItem,
  StyledListEventHours,
  WrapperHour,
  BgHour
};
